var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckmarkFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.33301 40C3.33301 49.7246 7.19609 59.0509 14.0724 65.9272C20.9488 72.8036 30.2751 76.6666 39.9997 76.6666C49.7243 76.6666 59.0506 72.8036 65.9269 65.9272C72.8033 59.0509 76.6663 49.7246 76.6663 40C76.6663 30.2754 72.8033 20.9491 65.9269 14.0727C59.0506 7.1964 49.7243 3.33331 39.9997 3.33331C30.2751 3.33331 20.9488 7.1964 14.0724 14.0727C7.19609 20.9491 3.33301 30.2754 3.33301 40ZM55.2015 31.6609C56.1188 30.6289 56.0259 29.0487 54.9939 28.1315C53.962 27.2142 52.3818 27.3071 51.4645 28.3391L35.4164 46.3931L28.4017 39.6289C27.4078 38.6705 25.8251 38.6993 24.8667 39.6932C23.9083 40.6871 23.9371 42.2698 24.931 43.2282L35.694 53.6068L55.2015 31.6609Z",
  fill: "url(#paint0_linear_1903_10163)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1903_10163",
  x1: 3.33301,
  y1: 76.6666,
  x2: 119.917,
  y2: 63.9705,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9900CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#153BFF"
})))));
export default SvgCheckmarkFilled;